import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const bookingsFirstNameViewer = {
    autoComplete: 'given-name',
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map